mutation VerifyPhoneNumber($phoneNumber: String!) {
    phoneNumberVerify(phoneNumber: $phoneNumber) {
        verificationCode
    }
}
